module.exports = __webpack_public_path__ + "static/20260515.b564ec1a.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/20260515.png
// module id = 1002
// module chunks = 2